import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-1cc8e575"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "message__avatar"
};
var _hoisted_2 = { class: "message__block" };
var _hoisted_3 = {
    key: 0,
    class: "message__name"
};
var _hoisted_4 = { class: "message__text-wrapper" };
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = { class: "message__time" };
var _hoisted_7 = { key: 0 };
var _hoisted_8 = { class: "message__avatar" };
var _hoisted_9 = {
    key: 0,
    class: "message__name"
};
var _hoisted_10 = { class: "message__audio audio" };
var _hoisted_11 = {
    key: 0,
    class: "flex items-center"
};
var _hoisted_12 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "bg-white h-4 w-[4px] rounded-md" }, null, -1); });
var _hoisted_13 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "bg-white h-4 w-[4px] ml-[3px] rounded-md" }, null, -1); });
var _hoisted_14 = { class: "w-full h-full ml-3" };
var _hoisted_15 = { class: "text-base mt-1 message__countdown" };
var _hoisted_16 = { class: "message__time" };
var _hoisted_17 = { key: 0 };
var _hoisted_18 = { class: "message__avatar" };
var _hoisted_19 = { class: "message__block" };
var _hoisted_20 = {
    key: 0,
    class: "message__name"
};
var _hoisted_21 = {
    key: 0,
    class: "file__icon file__icon--preview"
};
var _hoisted_22 = ["src"];
var _hoisted_23 = { class: "file__name" };
var _hoisted_24 = { class: "file__size" };
var _hoisted_25 = { class: "message__time" };
var _hoisted_26 = { class: "message__avatar" };
var _hoisted_27 = { class: "message__block" };
var _hoisted_28 = {
    key: 0,
    class: "message__name"
};
var _hoisted_29 = {
    key: 1,
    class: "message__text-wrapper"
};
var _hoisted_30 = ["innerHTML"];
var _hoisted_31 = ["src"];
var _hoisted_32 = { class: "file-image__time" };
import Avatar from '@common/ui/EAvatar/EAvatar.vue';
import Auth from '@common/modules/auth';
import { ICON_COLORS } from '@common/utils/Colors/Colors';
import { parseTextWithUrl } from '@common/utils/String/String';
import { downloadFileByURL, getHumanFileSize } from '@common/utils/File/File';
import EAudioPlayer from '@common/ui/EAudioPlayer/EAudioPlayer.vue';
import { useAudioUtils } from '@common/hooks/audio/useAudioUtils';
import { EXTENSIONS } from '@common/utils/Extension';
import { AuthRoles } from '@common/interfaces/utils';
import CEmployeeAvatar from '@common/components/CEmployeeAvatar.vue';
import { formatDate } from '@common/utils/Format/Format';
import { ChatStore, CoreStore, LightboxStore } from '@common/stores';
import { computed, ref } from 'vue';
import { StudentsStore } from '@school/modules/store';
import { useMounted } from '@vueuse/core';
import { FileStatusEnum } from '@common/enums/fileStatus.enum';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Message',
    props: {
        message: {},
        selected: { type: Boolean }
    },
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var audioPlayerRef = ref();
        var isMounted = useMounted();
        var chat = computed(function () { return ChatStore.contentChat; });
        var user = computed(function () { return CoreStore.user; });
        var isTeacher = computed(function () { return props.message.user.role === AuthRoles.ROLE_SCHOOL_ADMIN; });
        var isStudent = computed(function () { return Auth.isStudentUser(); });
        var isImage = computed(function () {
            // Если больше одного файла или файлов нет вовсе
            if (!props.message.file) {
                return false;
            }
            return RegExp('\.(jpg|png|webp|jpeg|gif)$', 'g').test(props.message.file.getName());
        });
        var isEdited = computed(function () { return props.message.createdAt !== props.message.updatedAt; });
        var canEdit = computed(function () {
            return (user.value &&
                ((chat.value.type === 'dialogue' && props.message.user.id === user.value.id) ||
                    (chat.value.type !== 'dialogue' && user.value.role !== AuthRoles.ROLE_STUDENT) ||
                    (chat.value.type !== 'dialogue' &&
                        user.value.role === AuthRoles.ROLE_STUDENT &&
                        props.message.user.id === user.value.id)));
        });
        var messageText = computed(function () { return parseTextWithUrl({
            text: props.message.text
        }); });
        var getDurationTimeFormat = computed(function () {
            var _a, _b;
            if (!((_a = props.message) === null || _a === void 0 ? void 0 : _a.audio)) {
                return '';
            }
            var audioUtils = useAudioUtils();
            var audioTime = +((_b = props.message.audio) === null || _b === void 0 ? void 0 : _b.audioTime);
            return audioUtils.getTimeFormat(audioTime);
        });
        var isMessageOwner = computed(function () { return user.value && props.message.user.id === user.value.id; });
        var currentTimeFormat = computed(function () {
            var _a;
            if (!isMounted.value)
                return 0;
            return (_a = audioPlayerRef.value) === null || _a === void 0 ? void 0 : _a.currentTimeFormat;
        });
        var isRecordPlay = computed(function () {
            var _a;
            if (!isMounted.value)
                return false;
            return (_a = audioPlayerRef.value) === null || _a === void 0 ? void 0 : _a.isRecordPlay;
        });
        var isFileLoading = computed(function () { var _a; return !((_a = props.message.file) === null || _a === void 0 ? void 0 : _a.hasStatus(FileStatusEnum.FINISHED)); });
        var downloadFile = function (file) {
            downloadFileByURL(file.getLink(), file.getName());
        };
        var showImage = function (url) {
            LightboxStore.singleLightboxShow(url);
        };
        var userClicked = function () {
            if (!Auth.isStudentUser() && props.message.user.id !== user.value.id && !isTeacher.value) {
                StudentsStore.showStudentProfile(props.message.user.id);
            }
        };
        var getFileColor = function (ext) {
            var color = '';
            for (var group in EXTENSIONS) {
                if (EXTENSIONS[group].includes(ext.toLowerCase())) {
                    color = ICON_COLORS[group];
                }
            }
            return color;
        };
        var play = function () {
            var _a;
            (_a = audioPlayerRef.value) === null || _a === void 0 ? void 0 : _a.toggleRecord();
        };
        return function (_ctx, _cache) {
            var _a;
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_button = _resolveComponent("e-button");
            var _directive_loading = _resolveDirective("loading");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([{
                        'message-wrapper--right': isMessageOwner.value,
                        'message-wrapper--can-select': _ctx.message.id && canEdit.value,
                        'message-wrapper--selected': _ctx.selected,
                    }, "message-wrapper"])
            }, [
                (!_ctx.message.fileType && _ctx.message.text)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass([{
                                'message--right': isMessageOwner.value,
                            }, "message"])
                    }, [
                        (!isMessageOwner.value && chat.value.type === 'group' || (chat.value.type === 'channel' && !isStudent.value))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                (_ctx.message.user.role !== _unref(AuthRoles).ROLE_STUDENT)
                                    ? (_openBlock(), _createBlock(CEmployeeAvatar, {
                                        key: 0,
                                        name: _ctx.message.user.name ? _ctx.message.user.name : _ctx.message.user.email,
                                        src: _ctx.message.user.avatar,
                                        uuid: _ctx.message.user.uuid,
                                        class: "!w-9 !h-9",
                                        onClick: _cache[0] || (_cache[0] = _withModifiers(function () { }, ["stop"]))
                                    }, null, 8, ["name", "src", "uuid"]))
                                    : (_openBlock(), _createBlock(Avatar, {
                                        key: 1,
                                        class: _normalizeClass([
                                            user.value && !isStudent.value && _ctx.message.user.id !== user.value.id ? 'cursor-pointer' : '',
                                        ]),
                                        "color-id": _ctx.message.user.id,
                                        name: _ctx.message.user.name ? _ctx.message.user.name : _ctx.message.user.email,
                                        src: _ctx.message.user.avatar,
                                        onClick: userClicked
                                    }, null, 8, ["class", "color-id", "name", "src"]))
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_2, [
                            ((chat.value.type === 'group' || chat.value.type === 'channel') && !isMessageOwner.value)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.message.user.name), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("p", {
                                    class: "message__text",
                                    innerHTML: messageText.value
                                }, null, 8, _hoisted_5),
                                _createElementVNode("p", _hoisted_6, [
                                    (isEdited.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Изменено"))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(_unref(formatDate)(_ctx.message.createdAt, "HH:mm")), 1)
                                ])
                            ])
                        ])
                    ], 2))
                    : (!_ctx.message.fileType && _ctx.message.audio)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass([{
                                    'message--right': isMessageOwner.value,
                                }, "message message--audio"])
                        }, [
                            _createElementVNode("div", _hoisted_8, [
                                (_ctx.message.user.role !== _unref(AuthRoles).ROLE_STUDENT)
                                    ? (_openBlock(), _createBlock(CEmployeeAvatar, {
                                        key: 0,
                                        name: _ctx.message.user.name ? _ctx.message.user.name : _ctx.message.user.email,
                                        src: _ctx.message.user.avatar,
                                        uuid: _ctx.message.user.uuid,
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(function () { }, ["stop"]))
                                    }, null, 8, ["name", "src", "uuid"]))
                                    : (chat.value.type === 'group' || (chat.value.type === 'channel' && !isStudent.value))
                                        ? (_openBlock(), _createBlock(Avatar, {
                                            key: 1,
                                            "color-id": _ctx.message.user.id,
                                            name: _ctx.message.user.name ? _ctx.message.user.name : _ctx.message.user.email,
                                            src: _ctx.message.user.avatar,
                                            onClick: userClicked
                                        }, null, 8, ["color-id", "name", "src"]))
                                        : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", {
                                class: "message__block",
                                onClick: _cache[2] || (_cache[2] = _withModifiers(function () { }, ["stop"]))
                            }, [
                                (chat.value.type === 'group' && !isMessageOwner.value)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.message.user.name), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_10, [
                                    (_ctx.message.audio.url)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                            _createVNode(_component_e_button, {
                                                class: "pause-play-wrapper",
                                                size: "nosize",
                                                type: "text",
                                                onClick: play
                                            }, {
                                                default: _withCtx(function () { return [
                                                    (isRecordPlay.value)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _hoisted_12,
                                                            _hoisted_13
                                                        ], 64))
                                                        : (_openBlock(), _createBlock(_component_e_icon, {
                                                            key: 1,
                                                            class: "w-4 h-4 text-white ml-0.5",
                                                            icon: "play-button-arrowhead"
                                                        }))
                                                ]; }),
                                                _: 1
                                            }),
                                            _createElementVNode("div", _hoisted_14, [
                                                _createVNode(EAudioPlayer, {
                                                    ref_key: "audioPlayerRef",
                                                    ref: audioPlayerRef,
                                                    audio: _ctx.message.audio.url,
                                                    "average-frequency": ((_a = _ctx.message.audio) === null || _a === void 0 ? void 0 : _a.audioAverageFrequency) || [],
                                                    class: "w-full h-[22px]"
                                                }, null, 8, ["audio", "average-frequency"]),
                                                _createElementVNode("div", _hoisted_15, _toDisplayString(currentTimeFormat.value) + "/" + _toDisplayString(getDurationTimeFormat.value), 1)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("p", _hoisted_16, [
                                        (isEdited.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Изменено"))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(_unref(formatDate)(_ctx.message.createdAt, "HH:mm")), 1)
                                    ])
                                ])
                            ])
                        ], 2)), [
                            [_directive_loading, false]
                        ])
                        : (_ctx.message.fileType === 'file' && _ctx.message.file)
                            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass([{
                                        'message--right': isMessageOwner.value,
                                    }, "message message--file"])
                            }, [
                                _createElementVNode("div", _hoisted_18, [
                                    (_ctx.message.user.role !== _unref(AuthRoles).ROLE_STUDENT)
                                        ? (_openBlock(), _createBlock(CEmployeeAvatar, {
                                            key: 0,
                                            name: _ctx.message.user.name ? _ctx.message.user.name : _ctx.message.user.email,
                                            src: _ctx.message.user.avatar,
                                            uuid: _ctx.message.user.uuid,
                                            class: "!w-9 !h-9",
                                            onClick: _cache[3] || (_cache[3] = _withModifiers(function () { }, ["stop"]))
                                        }, null, 8, ["name", "src", "uuid"]))
                                        : (chat.value.type === 'group' || (chat.value.type === 'channel' && !isStudent.value))
                                            ? (_openBlock(), _createBlock(Avatar, {
                                                key: 1,
                                                "color-id": _ctx.message.user.id,
                                                name: _ctx.message.user.name ? _ctx.message.user.name : _ctx.message.user.email,
                                                src: _ctx.message.user.avatar,
                                                onClick: userClicked
                                            }, null, 8, ["color-id", "name", "src"]))
                                            : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                    (chat.value.type === 'group' && !isMessageOwner.value)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.message.user.name), 1))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", {
                                        class: "message__file file",
                                        onClick: _cache[4] || (_cache[4] = function ($event) { return (downloadFile(_ctx.message.file)); })
                                    }, [
                                        (isImage.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                _createElementVNode("img", {
                                                    src: _ctx.message.file.getLink(),
                                                    alt: ""
                                                }, null, 8, _hoisted_22)
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: _normalizeClass([[
                                                        _ctx.message.file.getExtension().length > 3 ? 'text-xs' : 'text-sm',
                                                    ], "shrink-0 w-10 h-10 font-medium bg-red-500 rounded-lg mr-4 text-white flex items-center justify-center uppercase text-center leading-[10px]"]),
                                                style: _normalizeStyle({ background: getFileColor(_ctx.message.file.getExtension()) })
                                            }, _toDisplayString(_ctx.message.file.getExtension()), 7)),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.message.file.getName()), 1),
                                            _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(getHumanFileSize)(_ctx.message.file.getSize())), 1)
                                        ])
                                    ]),
                                    _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(formatDate)(_ctx.message.createdAt, "HH:mm")), 1)
                                ])
                            ], 2)), [
                                [_directive_loading, isFileLoading.value]
                            ])
                            : (_ctx.message.fileType === 'image' && _ctx.message.file)
                                ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                    key: 3,
                                    class: _normalizeClass([{
                                            'message--right': isMessageOwner.value,
                                        }, "message message--file-image"])
                                }, [
                                    _createElementVNode("div", _hoisted_26, [
                                        (_ctx.message.user.role !== _unref(AuthRoles).ROLE_STUDENT)
                                            ? (_openBlock(), _createBlock(CEmployeeAvatar, {
                                                key: 0,
                                                name: _ctx.message.user.name ? _ctx.message.user.name : _ctx.message.user.email,
                                                src: _ctx.message.user.avatar,
                                                uuid: _ctx.message.user.uuid,
                                                class: "!w-9 !h-9",
                                                onClick: _cache[5] || (_cache[5] = _withModifiers(function () { }, ["stop"]))
                                            }, null, 8, ["name", "src", "uuid"]))
                                            : (chat.value.type === 'group' || (chat.value.type === 'channel' && !isStudent.value))
                                                ? (_openBlock(), _createBlock(Avatar, {
                                                    key: 1,
                                                    "color-id": _ctx.message.user.id,
                                                    name: _ctx.message.user.name ? _ctx.message.user.name : _ctx.message.user.email,
                                                    src: _ctx.message.user.avatar,
                                                    onClick: userClicked
                                                }, null, 8, ["color-id", "name", "src"]))
                                                : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_27, [
                                        (chat.value.type === 'group' && !isMessageOwner.value)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.message.user.name), 1))
                                            : _createCommentVNode("", true),
                                        (chat.value.type === 'group')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                                _createElementVNode("p", {
                                                    class: "message__text",
                                                    innerHTML: messageText.value
                                                }, null, 8, _hoisted_30)
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", {
                                            class: "message__file-image file-image",
                                            onClick: _cache[6] || (_cache[6] = _withModifiers(function ($event) { return (showImage(_ctx.message.file.getLink())); }, ["stop"]))
                                        }, [
                                            _createElementVNode("a", null, [
                                                _createElementVNode("img", {
                                                    src: _ctx.message.file.getLink(),
                                                    alt: "ImageMessage",
                                                    class: "file-image__image"
                                                }, null, 8, _hoisted_31)
                                            ]),
                                            _createElementVNode("p", _hoisted_32, _toDisplayString(_unref(formatDate)(_ctx.message.createdAt, "HH:mm")), 1)
                                        ])
                                    ])
                                ], 2)), [
                                    [_directive_loading, isFileLoading.value]
                                ])
                                : _createCommentVNode("", true)
            ], 2));
        };
    }
});
